import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import { IcoBuilding24 } from '@onefootprint/icons';
import type { DataIdentifier, Locale } from '@onefootprint/request-types';
import { Divider } from '@onefootprint/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { UsLegalStatus } from '../utils/constants';
import type { UsLegalStatus as UsLegalStatusType } from '../utils/types';
import { CitizenshipFields } from './citizenship-fields';
import { CountryOfBirthField } from './country-of-birth-field';
import { StatusFields } from './status-fields';
import { VisaFields } from './visa-fields';
type UsLegalStatusFieldsProps = {
  locale?: Locale;
  onStatusChange: (newStatus: UsLegalStatusType) => void;
  disabledDis: DataIdentifier[];
};
export const UsLegalStatusFields = t0 => {
  const $ = _c(34);
  const {
    locale,
    onStatusChange,
    disabledDis
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.fields.usLegalStatus"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const {
    control
  } = useFormContext();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = diToFormData("id.us_legal_status");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== control) {
    t3 = {
      control,
      name: t2
    };
    $[2] = control;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const selectedLegalStatus = useWatch(t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IcoBuilding24 color="primary" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="flex gap-1 items-center">{t4}<span className="text-label-2 text-primary">{t5}</span></div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== disabledDis) {
    t7 = disabledDis.includes("id.us_legal_status");
    $[9] = disabledDis;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onStatusChange || $[12] !== t7) {
    t8 = <StatusFields onStatusChange={onStatusChange} disabled={t7} />;
    $[11] = onStatusChange;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Divider />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = locale ?? "en-US";
  let t11;
  if ($[15] !== disabledDis) {
    t11 = disabledDis.includes("id.nationality");
    $[15] = disabledDis;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11) {
    t12 = <CountryOfBirthField locale={t10} disabled={t11} />;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== disabledDis || $[21] !== locale || $[22] !== selectedLegalStatus) {
    t13 = selectedLegalStatus && selectedLegalStatus !== UsLegalStatus.citizen && <CitizenshipFields locale={locale ?? "en-US"} disabled={disabledDis.includes("id.citizenships")} />;
    $[20] = disabledDis;
    $[21] = locale;
    $[22] = selectedLegalStatus;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== disabledDis || $[25] !== locale || $[26] !== selectedLegalStatus) {
    t14 = selectedLegalStatus === UsLegalStatus.visa && <VisaFields locale={locale} disabledDis={disabledDis} />;
    $[24] = disabledDis;
    $[25] = locale;
    $[26] = selectedLegalStatus;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t6 || $[32] !== t8) {
    t15 = <div className="flex flex-col gap-4">{t6}{t8}{t9}{t12}{t13}{t14}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t6;
    $[32] = t8;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
function _temp($) {
  return $.title;
}